// returns true if search string is found inside target string
const search = (targetString, searchString) =>
	targetString.toLowerCase().includes(searchString.toLowerCase());

export default search;
